export const scrollLock = {
  mounted() {
    document.getElementsByTagName("body")[0].style.overflowY = "hidden";
  },
  beforeDestroy() {
    document.getElementsByTagName("body")[0].style.overflowY = "auto";
  },
}
